module.exports = __webpack_public_path__ + "static/img/main.8863f83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/UnderdogDetective/intro/main.jpg
// module id = pvdL
// module chunks = 0